module.exports = __webpack_public_path__ + "static/media/1000998.9cbd3297.png";